/*********************************************************
 * Third Components
*********************************************************/
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

/*********************************************************
 * Redux
*********************************************************/
import {
  showModalEditLandmark,
  createEditFleetLandmark
} from 'Redux/actions';

/*********************************************************
 * Components
*********************************************************/
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Select, Button, Input } from 'Components';

const ModalEditLandmark = (props) => {

  const { messages } = props

  const dispatch = useDispatch();
  const [groupSelect, setGroupSelect] = useState();
  const [note, setNote] = useState('');
  const [title, setTitle] = useState('');

  /*********************************************************
   * Get the redux properties
  *********************************************************/
  const {
    landmarkGroups
  } = useSelector((state) => state.entitySelectorRedux);

  const {
    smodalLandmarkEdit,
    landmarkItemsSelected
  } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);

  useEffect(() => {
    if (smodalLandmarkEdit && landmarkItemsSelected && landmarkItemsSelected.length > 0) {
      setTitle(landmarkItemsSelected ? landmarkItemsSelected[0]?.name || '' : '')
      setNote(landmarkItemsSelected ? landmarkItemsSelected[0]?.note || '' : '')
    }
  }, [landmarkItemsSelected])

  /*********************************************************
     * Event when the user select another landmark group
    *********************************************************/
  const onChangeLandmarkGroup = (event) => {
    setGroupSelect(event)
  }

  /*********************************************************
   * Load the landmark groups exclude param group
  *********************************************************/
  const loadLandmarkGroupsExclude = () => {
    if (landmarkItemsSelected) {
      return landmarkGroups.filter((item) => item.id != landmarkItemsSelected[0]?.groupId)
    }

    return landmarkGroups;
  }

  /*********************************************************
   * Close modal
  *********************************************************/
  const onHandleClose = () => {
    dispatch(showModalEditLandmark(false))
  }

  /*********************************************************
   * Update landmark 
  *********************************************************/
  const onUpdateLandmark = () => {
    if (landmarkItemsSelected && landmarkItemsSelected.length > 0) {
      let item = landmarkItemsSelected[0];
      let landmarksToUpdate = {
        id: item.id,
        groupId: item.groupId,
        name: item.name,
        latitude: item.latitude,
        longitude: item.longitude,
        shape: item.shape,
        radius: item.radius,
        address: item.address,
        city: item.city,
        zip: item.zip,
        state: item.state,
        country: item.country
      }

      if (groupSelect?.id) {
        landmarksToUpdate = {
          ...landmarksToUpdate,
          groupId: groupSelect.id
        }
      }
      if (note) {
        landmarksToUpdate = {
          ...landmarksToUpdate,
          note: note
        }
      }

      if (title) {
        landmarksToUpdate = {
          ...landmarksToUpdate,
          name: title
        }
      }
      dispatch(createEditFleetLandmark(landmarksToUpdate, true))
      onHandleClose(false)
    }
  }

  return (
    <Modal
      title={messages["realtimemaps_landmarks_edit_modal"]}
      open={smodalLandmarkEdit || false}
      handleClose={() => {
        onHandleClose()
      }}
      position="right"
      size="small"
    >
      <ModalBody>
        <div className='modalMLandmark'>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Input
                id="landmark-title"
                type="text"
                placeholder={messages['land_mark_title']}
                value={title}
                onChange={(text) => { setTitle(text); }}
                required
                requiredMessage={messages['required_field']}
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                id="landmarkGroup"
                value={groupSelect}
                onChange={(event) => onChangeLandmarkGroup(event)}
                options={loadLandmarkGroupsExclude()}
                textField="name"
                valueField="id"
                placeholder={messages['realtimemaps_landmarks_groups_update_placeholder']}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                id="landmark-note"
                type="textarea"
                placeholder={messages['realtimemaps_landmark_create_notes']}
                value={note}
                onChange={(text) => { setNote(text); }}
                maxLength={65000} //DB TEXT type
              />
            </Grid>
          </Grid>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          id={'btn-cancel-bulk-edit'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onHandleClose()
          }}
          className="btn-gray"
        >
          {messages['realtimemaps_landmarks_groups_delete_cancel']}
        </Button>
        <Button
          id={'btn-save-bulk-edit'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onUpdateLandmark()
          }}
          className="btn-blue"
          disabled={title.length <= 3}
        >
          {messages['save']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalEditLandmark